export default "__VITE_ASSET__C7sfrZ0J__"